import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Button } from '@/shared/components/ui'

const NotFoundPage = () => {
    const { t } = useTranslation()
    const theme = useTheme()
    const navigate = useNavigate()

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '60vh',
                gap: 2,
                textAlign: 'center',
                p: 4,
            }}
        >
            <Typography sx={{ fontSize: '64px', fontWeight: 700, lineHeight: 1, color: theme.palette.primary.main }}>
                404
            </Typography>
            <Typography sx={{ fontWeight: 700, fontSize: '20px' }}>
                {t('notFoundTitle')}
            </Typography>
            <Typography sx={{ color: 'text.secondary', fontSize: '14px', maxWidth: 360 }}>
                {t('notFoundMessage')}
            </Typography>
            <Button onClick={() => void navigate('/')} sx={{ mt: 2 }}>
                {t('notFoundBack')}
            </Button>
        </Box>
    )
}

export default NotFoundPage
